import React, { useRef, useState } from 'react';
import classNames from 'classnames';
import {Translate, useTranslation} from '../../../../config/TranslationProvider';
import EventsFilter from '../../../filter/EventsFilter';
import EventsListing from '../../../sections/EventsListing';
import MapMultipleEvents from '../../../map/MapMultipleEvents';
import ListingActionButton from '../../../partials/ListingActionButton';
import useScrollObserver from '../../../../util/useScrollObserver';

const EventsListingMain = ({
    eventGroups,
    fetchMore,
    canFetchMore,
    isFetchingMore,
    tags,
    categories,
    onSubmit,
    listType,
    setListType,
    filter,
    fixedFilter
}) => {
    const [showFilter, setShowFilter] = useState(false);

    const filterForm = (
        <EventsFilter
            tags={tags}
            categories={categories}
            onSubmit={onSubmit}
            filter={filter}
            fixedFilter={fixedFilter}
        />
    );

    const eventsFound = eventGroups[0].data.length > 0;

    const toolbarRef = useRef();
    const handleScroll = () => {
        if (!toolbarRef.current) {
            return;
        }

        if (window.scrollY >= 425) {
            toolbarRef.current.style.visibility = 'visible';
        } else {
            toolbarRef.current.style.visibility = 'hidden';
        }
    };

    useScrollObserver(handleScroll);

    return (
        <div className="row">
            {/* Events Filter */}
            <div className="col-lg-4 mt-lg-0">
                <div className="filter-dropdown">
                    <div className={classNames({
                        dropdown: true,
                        show: showFilter,
                    })}>
                        <button
                            id="filterDropdown"
                            type="button"
                            className="btn btn-primary dropdown-toggle"
                            aria-haspopup="true"
                            aria-expanded={showFilter}
                            aria-label={useTranslation('filter_open_close')}
                            onClick={e => {
                                e.target.blur();

                                setShowFilter(showFilter => !showFilter);
                            }}
                        >
                            Filter
                        </button>
                        <div aria-labelledby="filterDropdown" className={classNames({
                            'dropdown-menu': true,
                            show: showFilter,
                        })}>
                            {filterForm}
                        </div>
                    </div>
                </div>

                <div className="filter-wrapper">
                    <div className="events-filter">
                        {filterForm}
                    </div>
                    <div
                        ref={toolbarRef}
                        className="atbd_listing_action_btn default-ad-search btn-toolbar substitute-btn-toolbar"
                        role="toolbar"
                    >
                        <ListingActionButton btnType="list" listType={listType} setListType={setListType} />
                        <ListingActionButton btnType="grid" listType={listType} setListType={setListType} />
                        <ListingActionButton btnType="map" listType={listType} setListType={setListType} />
                    </div>
                </div>
            </div>

            {/* Events Listing */}
            <div className="col-lg-8 mt-lg-0">
                {!eventsFound && (
                    <div className="section-title">
                        <h2><Translate value="no_results" /></h2>
                    </div>
                )}

                {eventsFound && listType === 'map' && (
                    <MapMultipleEvents
                        initialEvents={eventGroups[0]}
                        filter={filter}
                    />
                )}
                {eventsFound && listType !== 'map' && (
                    <EventsListing
                        type={listType === 'grid' ? 'grid6' : 'grid12'}
                        eventGroups={eventGroups}
                        fetchMore={fetchMore}
                        canFetchMore={canFetchMore}
                        isFetchingMore={isFetchingMore}
                        categories={categories}
                    />
                )}
            </div>
        </div>
    );
};

export default EventsListingMain;
